import { GetStaticProps, GetStaticPaths } from 'next'
import React from 'react'

import Page from '@aletheia/common/components/Page'

import FundShow from '../../components/FundPage'
import {
  IFund,
  IPayoutReport,
  fetchFund,
  fetchFunds,
  fetchPayoutReportsByFund,
} from '../../contentful'

type FundSingleProps = {
  Fund: IFund
  PayoutReports: IPayoutReport[]
}

const FundSingle: React.FC<FundSingleProps> = ({ Fund, PayoutReports }) => {
  const { title, bannerImage } = Fund.fields
  const displayTitle = /Fund$/.test(title) ? title : `${title} Fund`
  return (
    <Page
      title={displayTitle}
      banner={bannerImage}
      variant="wide"
      breadcrumbsBase={{ href: '/funds', label: 'Funds' }}
    >
      <FundShow Fund={Fund.fields} PayoutReports={PayoutReports} />
    </Page>
  )
}

export default FundSingle

export const getStaticProps: GetStaticProps<
  FundSingleProps | { Fund: undefined; PayoutReports: undefined },
  { slug: string }
> = async ({ params }) => {
  if (!params?.slug) throw new Error('Missing slug')
  const Fund = await fetchFund(params.slug)
  const PayoutReports = await fetchPayoutReportsByFund(params.slug)
  if (!Fund)
    return {
      notFound: true,
    }
  return {
    props: { Fund, PayoutReports },
    revalidate: 20,
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const Funds = await fetchFunds()
  return {
    paths: Funds.map((Fund) => ({ params: { slug: Fund.fields.slug } })),
    fallback: 'blocking',
  }
}
